module.exports = __webpack_public_path__ + "static/Raleway-Italic-637a6bc0a206dab2e8f4dc4c54a79428.woff2";